<div *ngIf="includeHeader" class="header-bar mb-21 mct-flex mct-row mct-justify-end mct-items-center">
  <span *ngIf="!webContentSearchResult?.TotalCount; else resultsReturned" class="no-results">
    {{ 'web-content.search-grid.no-search-results' | translate | ucfirst }}
  </span>
  <ng-template #resultsReturned>
    <span>{{ 'web-content.search-grid.the-search-returned' | translate | ucfirst }}</span>
    &nbsp;
    <span class="f-wb">{{ webContentSearchResult.TotalCount }}</span>
    &nbsp;
    <span class="f-wb">{{ 'web-content.search-grid.pieces-of-web-content' | translate }}</span>
  </ng-template>
</div>

<p-table [showGridlines]="true" [value]="webContentSearchResult?.Result" [paginator]="true" [rows]="searchParams ? searchParams.PageSize : 10"
  [lazy]="true" [totalRecords]="webContentSearchResult?.TotalCount" (onLazyLoad)="lazyLoadWebContents($event)"
  data-cy="tableWebContentSearchResults">
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th class="content-id-column" pSortableColumn="ContentId">
        {{ 'web-content.search-grid.content-id' | translate }}
        <p-sortIcon field="ContentId"></p-sortIcon>
      </th>
      <th class="content-title" pSortableColumn="ContentTitle">
        {{ 'web-content.search-grid.title' | translate | ucfirst }}
        <p-sortIcon field="ContentTitle"></p-sortIcon>
      </th>
      <th class="content-type-column" pSortableColumn="ContentFormat">
        {{ 'web-content.search-grid.format' | translate | ucfirst }}
        <p-sortIcon field="ContentFormat"></p-sortIcon>
      </th>
      <th class="content-type-column" pSortableColumn="ContentTypeId">
        {{ 'web-content.search-grid.content-type' | translate | ucfirst }}
        <p-sortIcon field="ContentTypeId"></p-sortIcon>
      </th>
      <th *ngIf="includeProfile" class="profile-id-column" pSortableColumn="ProfileId">
        {{ 'web-content.search-grid.profile' | translate | ucfirst }}
        <p-sortIcon field="ProfileId"></p-sortIcon>
      </th>
      <th></th>
    </tr>
    <tr>
      <th>
        <p-inputNumber placeholder="{{ 'web-content.search-grid.filter-by-id' | translate | ucfirst }}"
          styleClass="p-column-filter" [(ngModel)]="searchParams.ContentId" (onInput)="filterChanged()"></p-inputNumber>
      </th>
      <th>
        <input pInputText placeholder="{{ 'web-content.search-grid.filter-by-title' | translate | ucfirst }}"
          styleClass="p-column-filter" [(ngModel)]="searchParams.ContentTitle" (input)="filterChanged()" />
      </th>
      <th>
        <p-select optionLabel="label" optionValue="value" [options]="webContentFormats"
          placeholder="{{ 'web-content.search-grid.filter-by-format' | translate | ucfirst }}"
          styleClass="p-column-filter" [(ngModel)]="searchParams.ContentFormat" (onChange)="filterChanged()" showClear
          appendTo="body"></p-select>
      </th>
      <th>
        <p-select optionLabel="ContentType" optionValue="ContentTypeID" [options]="webContentTypes"
          placeholder="{{ 'web-content.search-grid.filter-by-type' | translate | ucfirst }}"
          styleClass="p-column-filter" [(ngModel)]="searchParams.ContentTypeId" (onChange)="filterChanged()" showClear
          appendTo="body"></p-select>
      </th>
      <th *ngIf="includeProfile">
        <p-inputNumber placeholder="{{ 'web-content.search-grid.filter-by-profileid' | translate | ucfirst }}"
          styleClass="p-column-filter" [(ngModel)]="searchParams.ProfileId" (onInput)="filterChanged()"></p-inputNumber>
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-webContent>
    <tr>
      <td>
        {{ webContent.ContentID }}
      </td>
      <td>
        <div
          *ngIf="
            webContent.ContentFormat === webContentFormatEnum.Image || webContent.ContentFormat === webContentFormatEnum.Document;
            else plainText
          "
        >
          <a *ngIf="webContent.ContentFormat === webContentFormatEnum.Image" [href]="webContent.ContentUrl">
            {{ webContent.ContentTitle }}
          </a>
          <a *ngIf="webContent.ContentFormat === webContentFormatEnum.Document" (click)="navigateToPortalWebcontent(webContent.ContentID)">
            {{ webContent.ContentTitle }}
          </a>
        </div>
        <ng-template #plainText>
          {{ webContent.ContentTitle }}
        </ng-template>
      </td>
      <td class="content-format-column">
        {{ webContent.ContentFormat }}
      </td>
      <td class="content-type-column">
        {{ webContent.WebContentType?.ContentType }}
      </td>
      <td *ngIf="includeProfile">
        <a *ngIf="webContent.ProfileID" [routerLink]="['/profile', webContent.ProfileID]">{{ webContent.ProfileID }}</a>
      </td>
      <td>
        <div class="mct-flex mct-row mct-justify-center mct-items-center mct-gap-6">
          <a class="delete-link" (click)="confirmDeletion(webContent)" data-cy="aWebContentDeleteItem">{{
            'web-content.search-grid.delete' | translate | titlecase
            }}</a>

          <i class="light-grey">•</i>
          <wl-ephemeral-content-swap #contentSwap>
            <a ngxClipboard [cbContent]="
                webContent.ContentFormat === webContentFormatEnum.Image
                  ? webContent.ContentUrl
                  : webContentMemberPortalUrl + webContent.ContentID
              " (click)="contentSwap.show()">
              {{ 'web-content.search-grid.copy-url' | translate }}
            </a>
            <div class="wl-ephemeral-content">
              {{ 'web-content.search-grid.copied-to-clipboard' | translate | ucfirst }}
            </div>
          </wl-ephemeral-content-swap>

          <i class="light-grey" *ngIf="webContent.ContentFormat === webContentFormatEnum.Image">•</i>
          <wl-ephemeral-content-swap #contentSwapMemberPortalUrl
            *ngIf="webContent.ContentFormat === webContentFormatEnum.Image">
            <a ngxClipboard [cbContent]="webContentMemberPortalUrl + webContent.ContentID"
              (click)="contentSwapMemberPortalUrl.show()">
              {{ 'web-content.search-grid.copy-url-new' | translate }}
            </a>
            <div class="wl-ephemeral-content">
              {{ 'web-content.search-grid.copied-to-clipboard' | translate | ucfirst }}
            </div>
          </wl-ephemeral-content-swap>

          <i class="light-grey">•</i>
          <a (click)="editDialog.showModal(webContent.ContentID)">{{ 'web-content.search-grid.edit' | translate |
            titlecase }}</a>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-progressSpinner *ngIf="loading"></p-progressSpinner>
<wl-page-size-dropdown [pageSizes]="[20, 100, 0]" [(pageSize)]="searchParams.PageSize"
  (pageSizeChange)="pageSizeChanged()">
</wl-page-size-dropdown>

<wl-web-content-edit-dialog #editDialog [isReadOnly]="isReadOnly"
  (webContentSaved)="filterChanged()"></wl-web-content-edit-dialog>

<p-confirmDialog #cd header="{{ 'web-content.search-grid.delete-confirmation-header' | translate | titlecase }}"
  icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">{{ 'common.cancel' |
      translate | uppercase }}</button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="isReadOnly" (click)="cd.onAccept()"
      data-cy="btnWebContentConfirmDelete">
      {{ 'web-content.search-grid.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
